module.exports = __webpack_public_path__ + "static/media/artikel-heading.74a52236.svg";